import { AutoComplete, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import MainApiService from "../../../../../../../services/mainApi.service";
import { IGeneric } from "../../../../../../../models/generics";
import { TQuickAnswerForm } from "../QuickAnswerSchema";
import { useWatch } from "react-hook-form";

const GENERICS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApiService<IGeneric>(GENERICS_ROUTE);

const translationPath = "page.settings.quickAnswer.";

export const ShareTypeSelector = memo(() => {
  const { t } = useTranslation();

  const { setValue, control } = useFormContext<TQuickAnswerForm>();

  const currentShareType = useWatch({ name: "shareType", control });

  const changeHandler = useCallback(() => {
    setValue("user", null);
    setValue("ticketWorkspace", null);
    setValue("ticketChannel", null);
  }, [setValue]);

  return (
    <Grid item xs={12} sm={currentShareType ? 6 : 12}>
      <AutoComplete
        params={{ identifier: "SHARE_TYPE" }}
        getOptionLabel={(option) => {
          return option.name;
        }}
        onValueChange={changeHandler}
        size="small"
        clearIcon={false}
        label={t(translationPath + "share_type")}
        name="shareType"
        request={genericService.list}
      />
    </Grid>
  );
});
